// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import UISelect from 'UIComponents/input/UISelect';
import { Link } from 'foundations-components/transitional/components/Link';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { useCallback, useEffect, useState } from 'react';
import { usePrevious } from '../../hooks/usePrevious';
import { requestIdleCallback } from '../../utils/requestIdleCallback';
import { SearchBarInput } from './SearchBarInput';
import { jsx as _jsx } from "react/jsx-runtime";
const NoopExternalIcon = () => null;
export default function SearchBar({
  inputValue,
  onClear,
  onInputValueChange,
  onOpenChange,
  onResultClick,
  onSearchSubmit,
  open: initialOpen = false,
  use = 'default',
  options,
  isLoading,
  placeholder,
  readOnly,
  onSelectedOptionChange,
  menuStyle = {
    height: 'auto',
    maxHeight: '400px'
  },
  loadOptions
}) {
  const [searchInputValue, setSearchInputValue] = useState(inputValue);
  const [clearButtonClicked, setClearButtonClicked] = useState(false);
  const [open, setOpen] = useState(initialOpen);
  const prevInitialOpen = usePrevious(initialOpen);
  const isLink = use === 'link';
  const isExternalLink = use === 'external-link';
  const renderOption = useCallback(option => {
    if (option.href && (isLink || isExternalLink || option.seeAllButton)) {
      const {
        href,
        linkUse,
        dropdownText,
        text
      } = option;
      return /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
        _useButton: false,
        message: true,
        option: Object.assign({}, option, {
          dropdownText: /*#__PURE__*/_jsx(Link, {
            paddingBlock: "100",
            paddingInline: "300",
            ExternalIcon: NoopExternalIcon,
            external: isExternalLink,
            href: href,
            onMouseDown: evt => {
              evt.stopPropagation();
              if (onResultClick) {
                onResultClick(option);
              }
              if (isExternalLink) {
                requestIdleCallback(() => setOpen(false), 500);
              }
            },
            use: linkUse,
            children: dropdownText || text
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
      message: true,
      option: option
    });
  }, [isExternalLink, isLink, onResultClick]);
  const handleOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (clearButtonClicked) {
      setClearButtonClicked(false);
      return;
    }
    if (onOpenChange) {
      onOpenChange(value);
    }
    setOpen(value);
  }, [clearButtonClicked, onOpenChange]);
  const handleSubmit = useCallback(value => {
    setOpen(false);
    if (onSearchSubmit) {
      onSearchSubmit(value);
    }
  }, [setOpen, onSearchSubmit]);
  const handleInputValueChange = useCallback(e => {
    const value = e.target.value;
    setSearchInputValue(value);
    if (!value.trim()) {
      if (onClear) {
        onClear();
      }
      // Create a SyntheticEvent with the correct type
      if (onInputValueChange) {
        const syntheticEvent = Object.create(SyntheticEvent.prototype, {
          target: {
            value: {
              value: ''
            }
          },
          type: {
            value: 'change'
          }
        });
        onInputValueChange(syntheticEvent);
      }
    } else if (onInputValueChange) {
      onInputValueChange(e);
    }

    // Check if e is an instance of SyntheticEvent
    if (e && e instanceof SyntheticEvent) {
      setClearButtonClicked(true);
    }
  }, [onClear, onInputValueChange]);
  const handleInputKeyDown = useCallback(e => {
    const {
      key,
      target: {
        value: _value
      }
    } = e;
    const value = _value.trim();
    if (value && key === 'Enter') {
      e.preventDefault();
      handleSubmit(value);
    }
  }, [handleSubmit]);
  useEffect(() => {
    if (initialOpen !== prevInitialOpen) {
      setOpen(initialOpen);
    }
  }, [initialOpen, prevInitialOpen]);
  return /*#__PURE__*/_jsx(UISelect, {
    anchorType: "input",
    cache: false,
    "data-test-id": "storefront-search-bar",
    filterOptions: false,
    inputComponent: SearchBarInput,
    inputValue: searchInputValue,
    isLoading: isLoading,
    loadOptions: loadOptions,
    menuStyle: menuStyle,
    onInputKeyDown: handleInputKeyDown,
    onInputValueChange: handleInputValueChange,
    onOpenChange: handleOpenChange,
    onSelectedOptionChange: onSelectedOptionChange,
    open: open,
    optionRenderer: renderOption,
    options: options,
    placeholder: placeholder,
    readOnly: readOnly,
    value: null
  });
}